import { createRedact } from '@acorn/core';

export const redactor = createRedact({
	paths: [
		'**.lastNames',
		'**.contactEmail',
		'**.contactPhoneNumber',
		'**.registeredKeeper',
		'**.policyNumber',
		'**.policyToken',
		'**.policyReference',
	],
	censor: '[REDACTED]',
});
